import { compose } from 'recompose';

import connectToRouter from 'js/lib/connectToRouter';

export type WithZoomDevProps = {
  isDev: boolean;
};

export default (Component: $TSFixMe) =>
  compose<WithZoomDevProps, {}>(
    connectToRouter((router) => {
      const isDev = !!router.location.query.isDev || false;

      return {
        isDev,
      };
    })
  )(Component);
